var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMasterCardLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 26,
    viewBox: "0 0 42 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6338 2.78296H27.0005V23.2086H15.6338V2.78296Z",
    fill: "#888A8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9641 12.9952C16.9641 8.84522 18.9127 5.1642 21.9076 2.78235C19.7066 1.05017 16.9281 0.00366211 13.897 0.00366211C6.71585 0.00366211 0.90625 5.8137 0.90625 12.9952C0.90625 20.1768 6.71585 25.9868 13.8969 25.9868C16.928 25.9868 19.7065 24.9403 21.9076 23.208C18.9127 20.8623 16.9641 17.1453 16.9641 12.9952Z",
    fill: "#67686A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7318 12.9952C41.7318 20.1766 35.9222 25.9868 28.7412 25.9868C25.7101 25.9868 22.9316 24.9403 20.7305 23.208C23.7616 20.8263 25.6741 17.1453 25.6741 12.9952C25.6741 8.84522 23.7254 5.1642 20.7305 2.78235C22.9315 1.05017 25.7101 0.00366211 28.7412 0.00366211C35.9222 0.00366211 41.7318 5.84987 41.7318 12.9952Z",
    fill: "#B6B8BB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardLogoMobile);
export default __webpack_public_path__ + "static/media/master-card-logo-mobile.8e6cb19f39ce5c266f8f8e1bae59a236.svg";
export { ForwardRef as ReactComponent };